import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { toast } from 'react-toastify';
import { FaGoogle } from 'react-icons/fa';
import Loading from '../../shared/components/Loading/Loading';
import { useProductCatalog } from './hooks/useProductCatalog';
import { useProductSearch } from './hooks/useProductSearch';
import { useBulkSync } from './hooks/useBulkSync';
import { useSingleSync } from './hooks/useSingleSync';
import { syncGoogleProduct } from './services/integrationService';
import ProductSyncTable from './components/ProductSyncTable';
import SyncProgressPanel from './components/SyncProgressPanel';
import './Integrations.css';

const syncOneProduct = (product) => syncGoogleProduct(product.code);

const GoogleIntegrationPage = () => {
  const { products, count, loading } = useProductCatalog();
  const { term, setTerm, results, minLength } = useProductSearch(products);
  const { syncingCode, syncOne } = useSingleSync(syncOneProduct);
  const { syncing, syncedCount, failedCount, percent, runBulkSync } = useBulkSync(
    products,
    syncOneProduct
  );

  const handleSyncOne = async (product) => {
    try {
      await syncOne(product);
      toast.success(`Produto ${product.code} sincronizado com o Google.`, { autoClose: 4000 });
    } catch (err) {
      toast.error(`Não foi possível sincronizar o produto ${product.code}.`, { autoClose: 4000 });
    }
  };

  const handleSyncAll = async () => {
    await runBulkSync();
    toast.success('Sincronização com o Google concluída.', { autoClose: 4000 });
  };

  return (
    <div className="site-content">
      <div className="content-wrapper pt-6 pb-6">
        <Container fluid>
          <Row className="align-items-center mb-4">
            <Col>
              <h3 className="mb-0">
                <FaGoogle className="integrations-page__icon" color="#ea4335" />
                Google Shopping
              </h3>
              <p className="text-muted mb-0">Sincronize seu catálogo de produtos com o Google Shopping</p>
            </Col>
          </Row>

          <Row>
            <Col lg={7} className="mb-4">
              <div className="integrations-panel">
                <h5>Sincronizar produto específico</h5>
                <ProductSyncTable
                  term={term}
                  onTermChange={setTerm}
                  results={results}
                  onSync={handleSyncOne}
                  syncingCode={syncingCode}
                  minLength={minLength}
                  disabled={syncing}
                />
              </div>
            </Col>
            <Col lg={5} className="mb-4">
              <div className="integrations-panel">
                <h5>Sincronizar catálogo completo</h5>
                <SyncProgressPanel
                  label="Google"
                  totalCount={count}
                  syncedCount={syncedCount}
                  failedCount={failedCount}
                  percent={percent}
                  syncing={syncing}
                  onSyncAll={handleSyncAll}
                  disabled={Boolean(syncingCode)}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {loading && <Loading overlay />}
    </div>
  );
};

export default GoogleIntegrationPage;
